import { Pipe, PipeTransform } from '@angular/core';
import { MetaDataTypeEnum } from 'app/main/pages/settings/documentfields/metadata-item.dto';

@Pipe({
  name: 'filterMetadataTypes'
})

export class FilterMetadataTypesPipe implements PipeTransform {

  transform(allTypes, fieldSection) {
    if (fieldSection === 'person_field' || fieldSection === 'org_field') {
      return allTypes.filter(
        item => item.value === MetaDataTypeEnum.text || item.value === MetaDataTypeEnum.image
      );
    } else {
      return allTypes.filter(item => item.value !== MetaDataTypeEnum.image);
    }
  }

}
